import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';
import Button from '../../../../../components/Buttons/Button';
import LADSettlementCard from '../../Edit/Settlements/LADSettlementCard';

const CreateLADSettlements = ({ settlements, setSettlements }) => {
  const setEditMode = (index, val) => {
    const settlementsLocal = cloneDeep(settlements);
    settlementsLocal[index].editMode = val;
    setSettlements(settlementsLocal);
  };

  const handleAddNew = () => () => {
    let settlementsLocal = cloneDeep(settlements);
    let nextSequence = maxBy(settlementsLocal, ({ settlementSeq }) => Number(settlementSeq));
    nextSequence = nextSequence ? nextSequence.settlementSeq : 0;
    settlementsLocal = [
      {
        claimKey: 0,
        settlementSeq: nextSequence + 1,
        accountingCode: undefined,
        amount: undefined,
        dirtyFlag: 'i',
        isNew: true,
        editMode: true,
      },
      ...settlementsLocal,
    ];
    setSettlements(settlementsLocal);
  };

  const handleCancel = (index, isNew) => () => {
    const settlementsLocal = cloneDeep(settlements);
    if (isNew) {
      settlementsLocal.splice(index, 1);
    } else {
      settlementsLocal[index] = {
        ...settlementsLocal[index],
        editMode: false,
      };
    }
    setSettlements(settlementsLocal);
  };

  const handleSubmit = (data, index) => {
    const settlementsL = cloneDeep(settlements);
    settlementsL[index] = { ...data, dirtyFlag: 'i', editMode: false };
    setSettlements(settlementsL);
  };

  const handleDelete = (index) => () => {
    const settlementsL = cloneDeep(settlements);
    settlementsL.splice(index, 1);
    setSettlements(settlementsL);
  };

  return (
    <div className="d-flex flex-direction-column h-100 overflow-hidden">
      <Row className="align-items-center px-15" justify="space-between">
        <Col>{/* <PrimaryLabel className={"fw-700 f-18"}>Claim Items</PrimaryLabel> */}</Col>
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew()}>Add New Settlement</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <div className="px-15">
          {settlements.map((row, index) => (
            <LADSettlementCard
              settlementDetails={row}
              key={row.settlementSeq}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreateLADSettlements;
